import {
  STORE_ISFORCE_TO_SIGN_OUT,
  STORE_HardReleaseVersion,
  STORE_CartCheckoutData,
  STORE_Division_details,
  STORE_RATING_POSID,
  SECRET_KEY,
  STORE_CSP,
  ENTRY_MODE,
  MID,
  TABLE_NO,
} from "../../database/store-names";
import {
  api_checkAppStoreVersion,
  api_LoadMerchantForMID,
  api_checkbuildversion,
  api_StartupPageLoad,
  api_LoadDevisons,
} from "../../connection/api/api-home";
import {
  SET_ZONE_DESCRIPTION_HOME_SCREEN,
  ENCRYPT_STORAGE,
  SET_STARTUP,
} from "../../config/config";
import {
  set_dto_StartupPageLoadInfo,
  set_dto_Merchant,
} from "../../classes/dto-setters/dto-setter";
import { api_UpdateExpoPushToken } from "../../connection/api/api-profile";
import { GET_SET_STORED_DATA } from "../../database/get-stored-data";
import { get_Href_URL_Params } from "../../functions/funtion";
import { PT_HOME, PT_LAND } from "../../routes/stack/paths/pt-home";
import { SET_UPDATE_URL } from "../../util/update-config";
import { VALIDATE_CSP } from "../../config/csp";
import { dto_Merchant } from "../../classes/dto-merchant";
import { ToastMessage } from "../../components/toast-notification/toast";
import { SET_COLORS } from "../../util/color-config";
import { dto_common } from "../../classes/dto-common";
import { CHECK_NIC } from "../../functions/common-screen-functions";
import { Update } from "../../util/updateUrl";
import React from "react";

const SOFT_RELEASE_RELOAD_KEY = "SoftReleaseReloadedOnce";

const buildQrListPath = (mid, tableNo) => {
  const normalizedMid = String(mid || "")
    .trim()
    .replace(/^mid=/i, "");
  const normalizedTableNo = String(tableNo || "").trim();

  if (normalizedTableNo === "" || normalizedTableNo === "0") {
    return `/qr-list/${normalizedMid}`;
  }

  return `/qr-list/${normalizedMid}/${normalizedTableNo}`;
};

export default class Startup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CSP: "",
    };
  }

  async componentDidMount() {
    try {
      ENCRYPT_STORAGE.removeItem(STORE_CartCheckoutData);
      let { csp } = this.props.params;
      if ((await VALIDATE_CSP(csp)) === true) {
        let HardReleaseVersion = get_Href_URL_Params().ver;
        if (
          HardReleaseVersion === undefined ||
          HardReleaseVersion === null ||
          HardReleaseVersion === "" ||
          HardReleaseVersion === "undefined"
        ) {
          HardReleaseVersion = ENCRYPT_STORAGE.getItem(STORE_HardReleaseVersion);
        }
        ENCRYPT_STORAGE.setItem(STORE_CSP, csp.toUpperCase());
        if (
          HardReleaseVersion !== undefined &&
          HardReleaseVersion !== null &&
          HardReleaseVersion !== "" &&
          HardReleaseVersion !== "undefined"
        ) {
          ENCRYPT_STORAGE.setItem(STORE_HardReleaseVersion, HardReleaseVersion);
        }
        this.setState({ CSP: csp.toUpperCase() });
        await SET_STARTUP({ csp: csp, HardReleaseVersion: HardReleaseVersion });
        SET_COLORS({ CSP: csp.toUpperCase() });
        SET_UPDATE_URL({ CSP: csp });
        await CHECK_NIC();
        let objVersion = await api_checkbuildversion();
        if (objVersion === undefined || objVersion === null || objVersion === "") {
          await ToastMessage(1, "Unable to connect to server. Please try again.");
          return;
        }
        let CheckBuildVersion = JSON.parse(objVersion);
        if (CheckBuildVersion.Result === "UPDATE") {
          const alreadyReloaded =
            window.sessionStorage.getItem(SOFT_RELEASE_RELOAD_KEY) === "1";
          if (!alreadyReloaded) {
            window.sessionStorage.setItem(SOFT_RELEASE_RELOAD_KEY, "1");
            window.location.reload();
            return;
          }
          window.sessionStorage.removeItem(SOFT_RELEASE_RELOAD_KEY);
        }
        window.sessionStorage.removeItem(SOFT_RELEASE_RELOAD_KEY);
        if (CheckBuildVersion.Result === "Updating Memory") {
          // Alert.MessageBox({
          //   Tittle: "Info",
          //   Icon: "error",
          //   ConfirmButtonText: "OK",
          //   Text: "server Memory is being updated, Please re-open the app in few minutes",
          // });

          await ToastMessage(
            1,
            "server Memory is being updated, Please re-open the app in few minutes",
          );

          return;
        }
        let data = await api_checkAppStoreVersion();
        let objData = JSON.parse(data);
        if (objData.Result === "UPDATE") {
          //shud be ===
          let device = window.navigator.appVersion;
          if (device !== undefined) {
            // const appStoreLink =
            //   "https://apps.apple.com/us/app/apple-store/id1487298861";
            if (device.toUpperCase().includes("ANDROID")) {
              window.location.href = Update.ANDROIDstoreURL;
            }
            if (device.toUpperCase().includes("IPHONE")) {
              window.location.href = Update.IOSstoreURL;
            }
            if (device.toUpperCase().includes("IPAD")) {
              window.location.href = Update.IOSstoreURL;
            }
          }
        } else {
          dto_common.MemmoryURl = JSON.parse(data);
          ENCRYPT_STORAGE.setItem("ar3Mad32u4faTSrAUla", JSON.parse(data));

          if (dto_common.MemmoryURl !== "") {
            let stup = await api_StartupPageLoad();
            let x = JSON.parse(stup);
            await set_dto_StartupPageLoadInfo(x);

            this.setState({ isReady: true });

            let IsForcedToSignout = await api_UpdateExpoPushToken();
            let objIsForcedToSignout = JSON.parse(IsForcedToSignout);
            let objobjIsForcedToSignout = JSON.parse(objIsForcedToSignout);

            if (objobjIsForcedToSignout.length > 0) {
              ENCRYPT_STORAGE.setItem(
                STORE_ISFORCE_TO_SIGN_OUT,
                objobjIsForcedToSignout[0].IsForcedToSignout,
              );

              let PendingRatePOSID = objobjIsForcedToSignout[0].POSID;
              ENCRYPT_STORAGE.setItem(STORE_RATING_POSID, PendingRatePOSID);
            } else {
              ENCRYPT_STORAGE.setItem(STORE_ISFORCE_TO_SIGN_OUT, false);
            }

            const redirected = await this.HandleDaitonnQrRedirect(
              csp.toUpperCase(),
            );
            if (!redirected) {
              setTimeout(() => {
                if (csp.toUpperCase() === "AV") {
                  this.props.navigate(PT_LAND);
                  // this.props.navigate(PT_TYPE_LAND);
                } else {
                  this.props.navigate(PT_HOME);
                }
              }, 500);
            }
          }
        }
      }
      this.LoadDivisions();
    } catch (s) {
      console.error(s);
    }
  }

  async HandleDaitonnQrRedirect(csp) {
    if (csp !== "DT") {
      return false;
    }

    let from = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    if (from !== "QR") {
      return false;
    }

    await this.RunHomeDataSetupForQr();

    let mid = String(ENCRYPT_STORAGE.getItem(MID) || "")
      .trim()
      .replace(/^mid=/i, "");
    const tableNo = String(ENCRYPT_STORAGE.getItem(TABLE_NO) || "").trim();
    let secretKey = ENCRYPT_STORAGE.getItem(SECRET_KEY);
    if (secretKey !== "abc1234" || mid === "") {
      ENCRYPT_STORAGE.removeItem(SECRET_KEY);
      ENCRYPT_STORAGE.removeItem(ENTRY_MODE);
      ENCRYPT_STORAGE.removeItem(MID);
      ENCRYPT_STORAGE.removeItem(TABLE_NO);
      return false;
    }

    dto_Merchant.MID = mid;
    try {
      const data = await api_LoadMerchantForMID(4, mid, true);
      const objData = JSON.parse(data);
      const merchantInfo = JSON.parse(objData.MerchantInfo);
      if (Array.isArray(merchantInfo) && merchantInfo.length > 0) {
        await set_dto_Merchant(merchantInfo[0]);
      }
    } catch (error) {
      console.error("Startup QR merchant load failed:", error);
    }

    this.props.navigate(buildQrListPath(mid, tableNo));
    return true;
  }

  async RunHomeDataSetupForQr() {
    await GET_SET_STORED_DATA();
    if (dto_common.CSP !== "AV") {
      if (dto_common.ZoneId === 0) {
        dto_common.ZoneId = 1;
        dto_common.ZoneDescription = "Dehiwala";
      }
      SET_ZONE_DESCRIPTION_HOME_SCREEN(dto_common.ZoneDescription);
    } else {
      SET_ZONE_DESCRIPTION_HOME_SCREEN(dto_common.ZoneDescription);
    }
  }

  async LoadDivisions() {
    let data = await api_LoadDevisons();
    let x = JSON.parse(data);
    ENCRYPT_STORAGE.setItem(STORE_Division_details, x);
  }

  render() {
    return <>{this.RenderCspImages()}</>;
  }

  RenderCspImages() {
    if (this.state.CSP === "AV") {
      return (
        <img
          src={require("../home/images/pg-startup/av-splash.gif")}
          width={"100%"}
          alt=""
        />
      );
    } else if (this.state.CSP === "MK") {
      return (
        <img
          src={require("../home/images/pg-startup/mk-splash.png")}
          width={"100%"}
          alt=""
        />
      );
    } else if (this.state.CSP === "DT") {
      return (
        <img
          src={require("../home/images/pg-startup/dt-splash.png")}
          width={"100%"}
          alt=""
        />
      );
    } else {
      return null;
    }
  }
}
